export default __webpack_public_path__ + "static/pragicts-ourshare-banner-4-5a1d9b0d4c57b68fad07f3d87563816f.jpg";